// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__vesB5","row":"Projects_row__fXiPY","item":"Projects_item__TfdrC","line":"Projects_line__GRsRg","list":"Projects_list__eKl2s"};